import { writable } from "svelte/store";
// Toast notification stores
export const toastMessage = writable("");
export const showToast = writable(false);
export const highlightSettings = writable(false);
// Function to show toast notification
export function showSettingsToast(message = "To unhide items or manage preferences, click the ⚙ Settings button in the top right") {
    toastMessage.set(message);
    highlightSettings.set(true);
    showToast.set(true);
    // Auto-hide after 4 seconds
    setTimeout(() => {
        showToast.set(false);
        highlightSettings.set(false);
    }, 4000);
}
